import { CommonApiResponseType } from 'src/models/BaseApi';
import { SafeAnyType } from 'src/utils/safeAny';

export type BaseStoreEntityType<R = string, E = CommonApiResponseType> = {
  loading: boolean;
  error: E | null;
  response: R | null;
};

export type AnyRequestBaseStoreEntityType<R = SafeAnyType, E = CommonApiResponseType> = BaseStoreEntityType<R, E> & {
  uniqueId: string;
};

export const baseStoreEntityValue = <R = string, E = string>(
  response: R | null = null,
  loading = false,
  error: E | null = null
): BaseStoreEntityType<R, E> => ({
  loading,
  error,
  response,
});
